export default __webpack_public_path__ + "static/media/MC.d44a6425.ico";